import { uxProductFiltersRangeRender } from './product-filters';

/**
 *
 * ----------- Filtering Plugin -----------
 * Manage Ajax call to load the MC_GuidedNavigation cartridge
 */
/* eslint-disable */

export const init = () => {
  guidedNavigation();
  filterAndListing();
  additionalListeners();
  filtersCommonFunctionalities();
};

function guidedNavigation() {
  // Plugin constants
  const csts = {
    // Plugin identifier
    NAME: 'GuidedNavigationPlugin',
    AJAX_GUIDED_NAVIGATION: 'ajaxGuidedNavigation',
  };

  const methods = {
    // Initialize function, i.e plugin constructor.
    init: function(options) {
      return this.each(function() {});
    },

    ajaxGuidedNavigation: function(cartridgeId, nParameterValue, paramUrl) {
      reloadCartridgeContentCollection(
        $(this),
        cartridgeId,
        { N: nParameterValue },
        methods._ajaxGuidedNavigationSuccess,
        methods._ajaxGuidedNavigationError
      );

      //change url
      const baseUrl = $('#base-url-for-filters').val();
      if (history.pushState && paramUrl) {
        history.pushState(null, null, baseUrl + paramUrl);
      }
    },

    _ajaxGuidedNavigationSuccess: function($this, result) {
      $('.selectpicker').selectpicker('refresh');

      $('#product-filters').uxProductFiltersMethods();

      $(window).trigger('loadingProducts');

      decathlon.tools.slickReinitSlider(
        '.pl-element',
        '.slick-product',
        '.slick-thumbs',
        window.productListSlickSettings,
        productListSlickThumbsSettings
      );
    },

    _ajaxGuidedNavigationError: function(
      $this,
      jqXHR,
      textStatus,
      errorThrown
    ) {
      logError('ajaxGuidedNavigation error !');
    },

    ajaxLoadGlobalAverageRating: function(
      cartridgeId,
      nParameterValue,
      paramUrl
    ) {
      // update the replaced cartridge with data stored in the reloadable slot
      $('#' + cartridgeId).attr(
        'data-t-url',
        $('#ajax-MC_GlobalAverageRating').attr('data-t-url')
      );
      $('#' + cartridgeId).attr(
        'data-t-path',
        $('#ajax-MC_GlobalAverageRating').attr('data-t-path')
      );

      reloadCartridgeContentCollection(
        $(this),
        cartridgeId,
        { N: nParameterValue },
        methods.ajaxLoadGlobalAverageRatingSuccess,
        methods.ajaxLoadGlobalAverageRatingError
      );
    },

    ajaxLoadGlobalAverageRatingSuccess: function($this, result) {},

    ajaxLoadGlobalAverageRatingError: function(
      $this,
      jqXHR,
      textStatus,
      errorThrown
    ) {
      logError('ajaxLoadGlobalAverageRating error !');
    },
  };

  // Plugin entry point
  $.fn.GuidedNavigationPlugin = basePlugin(methods, csts.NAME);
}

//Plug to reload the filter and the listing
function filterAndListing() {
  // Plugin constants
  const csts = {
    // Plugin identifier
    NAME: 'FilterAndListingPlugin',
    AJAX_GUIDED_NAVIGATION: 'ajaxFilterAndListing',
  };

  const methods = {
    // Initialize function, i.e plugin constructor.
    init: function(options) {
      return this.each(function() {});
    },

    scrollto: function(delay, selector) {
      delay = delay || 50;
      selector = selector || '#product-filters-top';

      $('html, body').animate({ scrollTop: $(selector).offset().top }, delay);
    },

    ajaxFilterAndListing: function(nParameterValue, paramUrl) {
      const collapsedCollection = {};
      cube.$$('.m-filters-item-content.collapse').forEach(function(filter) {
        collapsedCollection[filter.id] = filter.classList.contains('in');
      });

      function ajaxSucess($this) {
        methods._ajaxFilterAndListingSuccess($this);
        methods._ajaxProductListingSuccess($this);

        for (let id in collapsedCollection) {
          if (cube.$('#' + id)) {
            const collContent = cube.$('#' + id);
            const collHolder = collContent.closest('.m-filters-faceting-item');
            const collToggler = collHolder.$('.toggle')
              ? collHolder.$('.toggle')
              : null;

            if (collapsedCollection[id]) {
              cube.$('#' + id).classList.add('in');
              if (collToggler) collToggler.classList.remove('collapsed');
            } else {
              cube.$('#' + id).classList.remove('in');
              if (collToggler) collToggler.classList.add('collapsed');
            }
          }
        }
      }

      const guidedNavContentPath = $('#product-filters-ajax-reload').attr('data-t-url');
      const guidedNavTemplate = $('#product-filters-ajax-reload').attr('data-t-path');
      const listingContentPath = $('#listing-product').attr('data-t-url');
      const listingTemplate = $('#listing-product').attr('data-t-path');
      const spotlightContentPath = $('#spotlight_floor_wrapper').attr('data-t-url');
      const spotlightTemplate = $('#spotlight_floor_wrapper').attr('data-t-path');
      const globalRatingContentPath = $('#ajax-MC_GlobalAverageRating').attr('data-t-url');
      const globalRatingTemplate = $('#ajax-MC_GlobalAverageRating').attr('data-t-path');

      let combinedAssemblerContent = '';
      if (guidedNavContentPath && guidedNavTemplate) {
        combinedAssemblerContent += guidedNavTemplate + '|' + guidedNavContentPath;
        combinedAssemblerContent += '||';
      }

      if (listingContentPath && listingTemplate) {
        combinedAssemblerContent += listingTemplate + '|' + listingContentPath;
        combinedAssemblerContent += '||';
      }

      if (spotlightContentPath && spotlightTemplate) {
        combinedAssemblerContent += spotlightTemplate + '|' + spotlightContentPath;
        combinedAssemblerContent += '||';
      }

      if (globalRatingContentPath && globalRatingTemplate) {
        combinedAssemblerContent += globalRatingTemplate + '|' + globalRatingContentPath;
      }

      const collectionList = createCartridgeCollection();
      collectionList.add('resultslist-browsed-content', {N: nParameterValue, assemblerContentCollections: combinedAssemblerContent});

      reloadManyCartridgeWithCollection(
        $(this),
        collectionList,
        true,
        ajaxSucess,
        methods._ajaxFilterAndListingError
      );

      decathlon.tools.showHideLoadingGif('show');

      //change url
      const baseUrl = $('#base-url-for-filters').val();
      if (history.pushState && paramUrl) {
        history.pushState(null, null, baseUrl + paramUrl);
      }
    },

    _ajaxFilterAndListingSuccess: function($this) {
      $this.FiltersCommonFunctionalitiesPlugin(
        'refreshPageElementsAfterRequest'
      );
    },

    _ajaxProductListingSuccess: function($this, result) {
      if ($this.attr('id') === 'cancel-filters') {
        setTimeout(() => {
          $('#product-filters').uxProductFiltersMethods('closeFilters');
        }, 500);
      }

      $(window).trigger('loadingProducts');
      $.fn.ListingPagination('updatePagination');
      window.slickProductsSlider();
      decathlon.tools.showHideLoadingGif('hide');

      cube.$$('.dkt-product__sticker__wrapper').forEach(sticker => {
        cube.sticker.displayDynamicSticker(sticker);
      });

      const newSortOptionsObject = JSON.parse(
        $('#product-list').attr('data-sort-options')
      );
      if (newSortOptionsObject) {
        cube.$('.dkt-select__options').innerHTML = '';
        newSortOptionsObject.forEach(el => {
          const tpl =
            '<li class="dkt-select__option ' +
            (el.selected
              ? 'dkt-select__option--selected" data-selected'
              : '"') +
            ' data-value="' +
            el.navigationState +
            '" data-url="' +
            el.contentPath +
            '" data-tnr-label="' +
            el.label
              .replace('property.sortOption.', '')
              .replace('.label', '') +
            '">' +
            window.Messages(el.label) +
            '</li>';
          cube.$('.dkt-select__options').insertAdjacentHTML('beforeEnd', tpl);
        });
      }
    },

    _ajaxFilterAndListingError: () => {
      logError('ajaxFilterAndListing error !');
      decathlon.tools.showHideLoadingGif('hide');
    },
  };

  // Plugin entry point
  $.fn.FilterAndListingPlugin = basePlugin(methods, csts.NAME);
}

//Plug to reload the filter and the listing after modifying the slider

export const ajaxPriceSliderListing = slider => {
  const collection = createCartridgeCollection();
  const nParameterValue = $('#price-url').val();
  const property = $('#price-property').val();
  const rangeValue = property + '%7CBTWN' + '+' + slider.from + '+' + slider.to;

  const guidedNavContentPath = $('#product-filters-ajax-reload').attr(
    'data-t-url'
  );
  const guidedNavTemplate = $('#product-filters-ajax-reload').attr(
    'data-t-path'
  );
  const listingContentPath = $('#listing-product').attr('data-t-url');
  const listingTemplate = $('#listing-product').attr('data-t-path');
  const spotlightContentPath = $('#spotlight_floor_wrapper').attr('data-t-url');
  const spotlightTemplate = $('#spotlight_floor_wrapper').attr('data-t-path');
  const globalRatingContentPath = $('#ajax-MC_GlobalAverageRating').attr(
    'data-t-url'
  );
  const globalRatingTemplate = $('#ajax-MC_GlobalAverageRating').attr(
    'data-t-path'
  );

  let combinedAssemblerContent = '';
  if (guidedNavContentPath && guidedNavTemplate) {
    combinedAssemblerContent += guidedNavTemplate + '|' + guidedNavContentPath;
    combinedAssemblerContent += '||';
  }

  if (listingContentPath && listingTemplate) {
    combinedAssemblerContent += listingTemplate + '|' + listingContentPath;
    combinedAssemblerContent += '||';
  }

  if (spotlightContentPath && spotlightTemplate) {
    combinedAssemblerContent += spotlightTemplate + '|' + spotlightContentPath;
    combinedAssemblerContent += '||';
  }

  if (globalRatingContentPath && globalRatingTemplate) {
    combinedAssemblerContent +=
      globalRatingTemplate + '|' + globalRatingContentPath;
  }

  collection.add('resultslist-browsed-content', {
    N: nParameterValue,
    assemblerContentCollections: combinedAssemblerContent,
    Nf: rangeValue,
  });

  reloadManyCartridgeWithCollection(
    $(this),
    collection,
    true,
    ajaxPriceSliderListingSuccess,
    ajaxPriceSliderListingError
  );

  //change url
  const baseUrl = $('#base-url-for-filters').val();
  const path = $('#range_filter_input').data('path');
  if (window.history.pushState) {
    window.history.pushState(null, null, baseUrl + path + 'Nf=' + rangeValue);
  }
};

const ajaxPriceSliderListingSuccess = $this => {
  $this.FiltersCommonFunctionalitiesPlugin('refreshPageElementsAfterRequest');

  const containerId = $this
    .closest('.m-filters-item-content.collapse')
    .attr('id');

  $('[id="' + containerId + '"]').addClass('in');
  $('[data-target="#' + containerId + '"]').removeClass('collapsed');
  window.decathlon.tools.showHideLoadingGif('hide');
  $.fn.ListingPagination('updatePagination');
  $('html, body').animate({ scrollTop: 0 }, 'slow');
};

const ajaxPriceSliderListingError = () => {
  logError('ajaxPriceSliderListing error !');
  window.decathlon.tools.showHideLoadingGif('hide');
};

const additionalListeners = () => {
  jQuery('body')
    .GuidedNavigationPlugin()
    .on('click', '#linkRefreshListing', function(event) {
      event.preventDefault();
      (function($this) {
        $this.GuidedNavigationPlugin('ajaxGuidedNavigation', 'listing-product', $this.attr('name') );
        $this.GuidedNavigationPlugin('ajaxLoadGlobalAverageRating', 'globalAverageRating', $this.attr('name') );
      })(jQuery(this));
    });



  jQuery('body')
    .FilterAndListingPlugin()
    .on('change', 'select.selectOptionFilter', function() {
      (function($this) {
        const selected = $this.find('option:selected');

        if (selected)
          $this.FiltersCommonFunctionalitiesPlugin(
            'reloadListingCartridges',
            $this.val(),
            selected.data('url')
          );
      })(jQuery(this));
    });




  jQuery('body')
    .GuidedNavigationPlugin()
    .on('click', '.removeFilter', function(event) {
      //US 33817 : ANALYTICS Set filters in data layer
      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.filters.resetFilters(this);
      }

      // if filter list contains a category, we reload the page
      if ($('#breadCrumbsFilters').find('a[data-filter-name="product.category"]').length) {
        decathlon.tools.showHideLoadingGif('show');
      } else {
        event.preventDefault();

        (function($this) {
          $this.FilterAndListingPlugin('ajaxFilterAndListing', $this.data('nvalue'), $this.data('url'));
          $this.GuidedNavigationPlugin('ajaxLoadGlobalAverageRating','globalAverageRating', $this.data('nvalue'));
          $this.FilterAndListingPlugin('scrollto');
        })(jQuery(this));
      }
    });



  jQuery('body')
    .GuidedNavigationPlugin()
    .on('click', '#cancel-filters', function(event) {
      event.preventDefault();
      (function($this) {
        const nValueBeforeOpeningFilters = $('#base-url-for-filters').data('original-filter-dimension');
        const urlBeforeOpeningFilters = $('#base-url-for-filters').data('original-url');

        if (history.pushState && urlBeforeOpeningFilters) {
          history.pushState(null, null, urlBeforeOpeningFilters);
        }

        $this.FilterAndListingPlugin('ajaxFilterAndListing', nValueBeforeOpeningFilters, '');
        $this.GuidedNavigationPlugin('ajaxLoadGlobalAverageRating', 'globalAverageRating', nValueBeforeOpeningFilters);
        $this.FilterAndListingPlugin('scrollto');

        $('#base-url-for-filters').data('original-filter-dimension', '');
        $('#base-url-for-filters').data('original-url', '');
      })(jQuery(this));

      $('#product-filters').uxProductFiltersMethods('closeFilters');
    });



  jQuery('body')
    .GuidedNavigationPlugin()
    .on(
      'change',
      '.checkboxFilter, .categoryFilter, .store-filter__toggle',
      function() {
        const doTheReload = function($this) {
          $this.FiltersCommonFunctionalitiesPlugin('reloadListingCartridges', $this.val(), $this.data('url'));

          // do not scroll to top if we click to show more button
          if (
            $this.parent('label.filter-show-more').length === 0 &&
            !$this.hasClass('store-filter__toggle')
          ) {
            $this.FilterAndListingPlugin('scrollto');
          }
        };

        if (!this.hasAttribute('data-url')) {
          this.value = cube.$('.sort-options-default-values').value;
        }

        const _this = $(this);

        cube.event.send('doTheReload');

        if (this.classList.contains('store-filter__toggle')) {
          this.classList.add('store-filter__toggle--loading');
          cube.ajax
            .post(
              'rest/model/com/decathlon/cube/commerce/locations/LocationActor/enableStoreFilter',
              { enableFilter: _this.is(':checked') }
            )
            .onSuccess(function() {
              doTheReload(_this);
              _this.removeClass('store-filter__toggle--loading');
              _this.removeAttr('data-url value');
            })
            .onError(function() {
              _this.removeClass('store-filter__toggle--loading');
              cube.alert.error(Messages('failed'));
            })
            .call();
        } else {
          doTheReload(_this);
        }
      }
    );
};

/**
 *
 * ----------- FiltersCommonFunctionalitiesPlugin -----------
 * Plugin to hold common functionality used by the different Filters Plugin.
 */
function filtersCommonFunctionalities() {
  const csts = {
    NAME: 'FiltersCommonFunctionalitiesPlugin',
  };

  const methods = {
    init: function(options) {
      return this.each(function() {});
    },

    /**
     * Refresh already loaded elements, used after ajax call sucess.
     */

    refreshPageElementsAfterRequest: function() {

      $('.selectpicker').selectpicker('refresh');

      uxProductFiltersRangeRender();
      $('#product-filters').uxProductFiltersMethods();

      // Update counts of filtered product
      $('.product-sorting-bar .number').text(
        $('#product-filters-ajax-reload').data('total-numrecs')
      );

      cube.event.send('listPageElementsRefresh');
    },

    /**
     * Reloads cartridges to reflect new applied filters.
     *
     * @param nParameterValue The N parameter value with dimensions from filters.
     * @param paramUrl The new url with dimensions from filters.
     */
    reloadListingCartridges: function(nParameterValue, paramUrl) {
      $.fn.FilterAndListingPlugin(
        'ajaxFilterAndListing',
        nParameterValue,
        paramUrl
      );
    },
  };
  // Plugin entry point
  $.fn.FiltersCommonFunctionalitiesPlugin = basePlugin(methods, csts.NAME);
}



// WEBPACK FOOTER //
// ./src/catalog/product-list/filter.js